const specialScrollbar = {
  scrollbarWidth: "thin",
  //paddingRight: 6,
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-track": {
    display: "none"
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: "3px",
    backgroundColor: "#c1c1c1",
    "&:hover": {
      backgroundColor: "#a8a8a8",
    }
  }
};

export {
  specialScrollbar
}
